/* Silhouet partnership page: the film's Replay button, and honoring
   prefers-reduced-motion by leaving the film on its poster until asked. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setUp(figure) {
    var video = figure.querySelector('video');
    var button = figure.querySelector('.silhouet-partnership-replay');
    if (!video) return;

    function applyMotionPreference() {
      if (reduce.matches) {
        video.removeAttribute('autoplay');
        video.removeAttribute('loop');
        video.pause();
        if (button) button.lastChild.nodeValue = ' Play';
      } else if (button) {
        button.lastChild.nodeValue = ' Replay';
      }
    }

    applyMotionPreference();
    if (typeof reduce.addEventListener === 'function') {
      reduce.addEventListener('change', applyMotionPreference);
    }

    if (button) {
      button.addEventListener('click', function () {
        video.currentTime = 0;
        var playing = video.play();
        if (playing && typeof playing.catch === 'function') playing.catch(function () {});
      });
    }
  }

  function init() {
    var figures = document.querySelectorAll('.silhouet-partnership-film');
    for (var i = 0; i < figures.length; i += 1) setUp(figures[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders sections on edit; wire the new DOM back up.
  document.addEventListener('shopify:section:load', init);
})();
